export default "__VITE_ASSET__a2kfsu$0__"